import { Injectable } from '@angular/core';
import { loadAccountCountries } from '@epicuro-next/state/accounts-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';

import {
  closeDropShipModal,
  closeRejectReviewerModal,
  closeRequestReviewerModal,
  makePendingDropShipModal,
  makePendingRejectReviewerModal,
  makePendingRequestReviewerModal,
  openDropShipModal,
  rejectBasket,
  rejectBasketFailure,
  rejectBasketSuccess,
  setDropShip,
  setDropShipFailure,
  setDropShipSuccess,
  submitForReview,
  submitForReviewFailure,
  submitForReviewSuccess,
} from '../actions';

@Injectable()
export class BasketModalsEffects {
  constructor(private actions$: Actions) {}

  public loadCountries$ = createEffect(() =>
    this.actions$.pipe(
      ofType(openDropShipModal),
      map(() => loadAccountCountries()),
    ),
  );

  public dropShipModalPending$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setDropShip),
      map(() => makePendingDropShipModal()),
    ),
  );

  public dropShipModalFinish$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setDropShipSuccess, setDropShipFailure),
      map(() => closeDropShipModal()),
    ),
  );

  public requestReviewerPending$ = createEffect(() =>
    this.actions$.pipe(
      ofType(submitForReview),
      map(() => makePendingRequestReviewerModal()),
    ),
  );

  public requestReviewerFinish$ = createEffect(() =>
    this.actions$.pipe(
      ofType(submitForReviewSuccess, submitForReviewFailure),
      map(() => closeRequestReviewerModal()),
    ),
  );

  public rejectReviewerPending$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rejectBasket),
      map(() => makePendingRejectReviewerModal()),
    ),
  );

  public rejectReviewerFinish$ = createEffect(() =>
    this.actions$.pipe(
      ofType(rejectBasketSuccess, rejectBasketFailure),
      map(() => closeRejectReviewerModal()),
    ),
  );
}
